require('./cardContract.scss');
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { CARD_DEBIT, CARD_CREDIT, CARD_ECARD } = require('constants/index');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const creditKeys = ['contractNumber', 'titularName', 'limit', 'address'];
const debitKeys = ['contractNumber', 'titularName', 'chargeAccount', 'address'];
const ecardKeys = ['contractNumber', 'titularName', 'chargeAccount', 'address'];
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
// @helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @utilities
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
// @constants
const { R42_BENEFITS_AND_INSURANCE, R42_BENEFITS_AND_INSURANCE_ACCESS, R42_BENEFITS_AND_INSURANCE_SECTION } = require('constants/flagBasedFeatures');
const { R42_CARD_OFF } = require('constants/cardR42States');
//@data
const { cardPolicies } = require('constants/cardBenefits');

class CardContract extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getKeys(immCard) {
        const { immFlagBasedFeatures } = this.props;
        const r42BenefitsAndInsuranceFlag = !!immFlagBasedFeatures && immFlagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE);
        const r42BenefitsAndInsuranceSection = !!immFlagBasedFeatures && immFlagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE_SECTION);

        let keys;
        switch (immCard.get('type')) {
            case CARD_CREDIT:
                keys = creditKeys;
                break;
            case CARD_DEBIT:
                keys = debitKeys;
                break;
            case CARD_ECARD:
                keys = ecardKeys;
                break;
            default:
                return [];
        }
        // jorge.zapata in order to not modify the original array, we clone it and then add the new key
        keys = [...keys];

        if (immCard.get('isOpenYoung')) {
            keys.splice(3, 0, 'openyoungBeneficiaryName');
        }
        if (immCard.get('isDiamond') || immCard.get('isPremium') || ((immCard.get('isR42MasterCard') || immCard.get('isR42BetaalPasCard') || immCard.get('isMetallic')) && r42BenefitsAndInsuranceSection)
        || (immCard.get('isR42') && r42BenefitsAndInsuranceFlag && !immCard.get('isNerudaCard') && !immCard.get('isVanityCard'))) {
            keys.push('benefitsAndPolicies');
        } else if (!immCard.get('isViaT')) {
            keys.push('policy');
        }
        return keys;
    }

    buildItems(keys) {
        const {
            cardId,
            immCard,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const plainAmountObject = getPlainAmountObject(immCard.get('limit'));
        return keys.map((key, index) => {
            let value, link;

            switch (key) {
                case 'contractNumber':
                    value = immCard.get('fullContractNumber');
                    break;
                case 'chargeAccount':
                    value = `${immCard.get('associatedAccount')}`;
                    break;
                case 'titularName':
                    value = immCard.get(key);
                    break;
                case 'openyoungBeneficiaryName':
                    value = immCard.get('beneficiaryName');
                    break;
                case 'limit':
                    value = (
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            trimDecimals
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    );
                    if (cardValidationRules.CARD_MODIFY_LIMIT.validator({immCard, isNerudaUser: immProfile.get('isNerudaUser')})) {
                        link = (
                            <OKLink
                                modifier="emphasize"
                                to={`/myprofile/cards/${cardId}/modify-limit`}
                                id={'btnCardDetailsLimitLink'}
                            >
                                <FormattedText value="cardDetails-limitLink" />
                            </OKLink>
                        );
                    }
                    break;
                case 'address':
                    value = `${immProfile.get('nombreDeVia')} ${immProfile.get('numeroDeVia')}`;
                    break;
                case 'benefitsAndPolicies':
                    let typeOfCard = 'r42';

                    if (immCard.get('isDiamond')){
                        typeOfCard = 'diamond';
                    } else if (immCard.get('isPremium')){
                        typeOfCard = 'premium';
                    }

                    const benefitsLink = `/myprofile/cards/${cardId}/benefits/${typeOfCard}`;
                    const r42BenefitsAndInsurance = !!immFlagBasedFeatures && immFlagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE);
                    const r42BenefitsAndInsuranceAccess = !!immFlagBasedFeatures && immFlagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE_ACCESS);
                    const r42BenefitsAndInsuranceSection = !!immFlagBasedFeatures && immFlagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE_SECTION);
                    const travelPlusStatus = immCard.getIn(['travelPlus', 'status']) || '';

                    if (typeOfCard === 'r42' && (!r42BenefitsAndInsurance || !r42BenefitsAndInsuranceAccess || immCard.get('isMetallic') || travelPlusStatus === R42_CARD_OFF) && ((immCard.get('isR42MasterCard') || immCard.get('isR42BetaalPasCard') || immCard.get('isMetallic')) && !r42BenefitsAndInsuranceSection )){

                        // Returning null here to avoid rendering a benefits title without content
                        return null;
                    } else {
                        link = (
                            <OKLink
                                id="btnCardDetailsbenefitsAndPoliciesLink"
                                modifier="emphasize"
                                to={benefitsLink}
                            >
                                <FormattedText value="cardDetails-benefitsAndPoliciesLink" />
                            </OKLink>
                        );
                    }
                    break;
                case 'policy':
                    const productType = immCard.get('newProduct');
                    const productSubType = immCard.get('productSubType');
                    const cardPoliciesProduct = cardPolicies[productType];

                    if (cardPoliciesProduct && cardPoliciesProduct[productSubType]) {
                        const policyLink = cardPoliciesProduct[productSubType].link;

                        link = (
                            <OKLink
                                modifier="emphasize"
                                to={policyLink}
                                id={'btnCardPolicyLink'}
                                target="_blank"
                            >
                                <FormattedText value="cardDetails-policyLink" />
                            </OKLink>
                        );
                    } else {
                        // Returning null here to avoid rendering a policy title without content
                        return null;
                    }

                    break;
            }

            return (
                <OKInformativeListItem key={index} title={`cardDetails-${key}`}>
                    <div className="card-contract__value">
                        {value}
                    </div>
                    <div>
                        {link}
                    </div>
                </OKInformativeListItem>
            );
        });
    }

    buildCollectiveTag() {
        const { immCard } = this.props;
        const isDiamondCard = immCard.get('isDiamond');
        const contentKey = isDiamondCard ? "hireCardSidebar-collectiveTooltipContentDiamondPack" : "contractSummary-collectiveTooltipContent";
        const immProduct = immCard.get('product');
        const product = {
            type: immProduct.get('type'),
            subType: immProduct.get('subtype'),
            standard: immProduct.get('standard')
        };
        return (
            <CollectiveTag
                extraClass="pull-right card-contract__btag-container"
                productType={product}
                tooltipContent={contentKey}
            />
        )
    }

    render() {
        const { immCard } = this.props;
        const itemsContent = this.buildItems(this.getKeys(immCard));
        const headerTitle = formatText('cardMoreOptions-infoContract');

        return (
            <div className="card-contract">
                <header className="card-contract__title">
                    {this.buildCollectiveTag()}
                    <OKBoxTitle value={headerTitle} />
                </header>
                <OKInformativeList title="cardDetails-contractTitle" columns={2}>
                    {itemsContent}
                </OKInformativeList>
            </div>
        );
    }
}

CardContract.propTypes = {
    cardId: PropTypes.string.isRequired,
    immCard: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
};

module.exports = CardContract;
